import * as z from "zod";

// Public pre-auth lookup: resolves a referrer referralToken to co-brand /signup.
export const getSignupReferrerBranding = {
  name: "getSignupReferrerBranding" as const,
  input: z.object({ referralToken: z.string().max(64) }),
  output: z
    .object({
      referrerName: z.string().max(256),
      logoUrl: z.string().max(2048).nullable(),
    })
    .nullable(),
};
